// the request types configured with this performance level are picked up ONLY on emergency cases
export const EMERGENCY_PERFORMANCE_LEVEL = "EMERGENCY";

// the column title and the accent colour of that level, the saved value stays EMERGENCY
export const EMERGENCY_PERFORMANCE_LABEL = "EMERGENCY ONLY";
export const EMERGENCY_PERFORMANCE_COLOR = "#C48AF0";
export const EMERGENCY_PERFORMANCE_BORDER = "#373737";

/**
 * The name to show for a request type, the loaded request types hold the names,
 * the not loaded ones are shown with their values
 */
export function getRequestTypeName(requestTypeValue, loadedRequestTypes) {
  if (requestTypeValue === "ALL") {
    return "All request types";
  }
  let requestType = loadedRequestTypes.find((rt) => rt.VALUE === requestTypeValue);
  return requestType !== undefined ? requestType.NAME : requestTypeValue.replace(/_/g, " ");
}

/**
 * Group the requests to show them in the emergency only summary
 *
 * @param requests [{modality, requestTypeName}]
 * @returns [{modality, requestTypes}] sorted by modality, with distinct request types
 */
/**
 * How many distinct requests are in a grouped summary, so the shown count matches the shown list
 *
 * @param groupedRequests [{modality, requestTypes}] as returned by groupRequestsByModality
 */
export function countGroupedRequests(groupedRequests) {
  return groupedRequests.reduce((total, request) => total + request.requestTypes.length, 0);
}

export function groupRequestsByModality(requests) {
  let groupedRequests = {};
  for (const request of requests) {
    if (groupedRequests[request.modality] === undefined) {
      groupedRequests[request.modality] = [];
    }
    if (!groupedRequests[request.modality].includes(request.requestTypeName)) {
      groupedRequests[request.modality].push(request.requestTypeName);
    }
  }
  return Object.keys(groupedRequests)
    .sort()
    .map((modality) => ({ modality: modality, requestTypes: groupedRequests[modality].sort() }));
}
